import { Badge } from '@bbpos/ui';
import type { PurchaseOrderStatus } from './types';

type BadgeVariant = 'draft' | 'ordered' | 'partial' | 'success' | 'danger';

const STATUS_MAP: Record<PurchaseOrderStatus, { label: string; variant: BadgeVariant }> = {
  DRAFT: { label: 'Draft', variant: 'draft' },
  ORDERED: { label: 'Ordered', variant: 'ordered' },
  PARTIALLY_RECEIVED: { label: 'Partial', variant: 'partial' },
  RECEIVED: { label: 'Received', variant: 'success' },
  CANCELLED: { label: 'Cancelled', variant: 'danger' },
};

export interface POStatusBadgeProps {
  status: PurchaseOrderStatus;
  size?: 'sm' | 'md';
}

export function POStatusBadge({ status, size = 'sm' }: POStatusBadgeProps) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.DRAFT;
  return (
    <Badge variant={meta.variant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
